import { useContextSelector } from "use-context-selector";
import ThemeContext from "../../context/ThemeContext";
import {
  filterarcade,
  filtercasion,
  filtercrash,
  filterfishing,
  filterlotto,
  filterslot,
  filtertable,
} from "./ListHome";
import { isMobile } from "react-device-detect";

const FilterCasino = ({ active, setActiveInner, activeInner, setShow }) => {
  let object = {
    casino: filtercasion,
    slots: filterslot,
    table: filtertable,
    crash: filtercrash,
    fishing: filterfishing,
    arcade: filterarcade,
    lottery: filterlotto,
  };
  const theme = useContextSelector(ThemeContext, (ctx) => {
    return ctx.theme;
  });
  // Function to update the image URL based on theme
  const getImageUrl = (url) => {
    return url;
  };
  return (
    <div className="ng-tns-c2684251700-888 ng-trigger ng-trigger-staggerFadeAnimation tab search-tab brand-tab ng-star-inserted">
      <ul className="item-ani ng-tns-c2684251700-888">
        <li
          onClick={() => setActiveInner("all")}
          className={`condition-groups ${activeInner == "all" ? "active" : ""}`}
        >
          <div
            className="icon-all ng-tns-c2684251700-888 ng-star-inserted"
            style={{
              backgroundImage:
                theme == "dark"
                  ? `url("/assets/Icon/icon-filter-all.svg")`
                  : `url("/assets/IconDark/icon-filter-all-black.svg")`,
            }}
          />
        </li>
        {object[active]?.map((res) => {
          return (
            <li
              onClick={() => setActiveInner(res?.name)}
              className={`condition-groups ${
                activeInner == res?.name ? "active" : ""
              }`}
            >
              <div className="condition-groups__inner ng-tns-c2684251700-888 ng-star-inserted">
                <img
                  className="ng-tns-c2684251700-888"
                  alt="provider-awcmpt"
                  src={getImageUrl(res?.image)}
                  loading="lazy"
                />
                <p className="ng-tns-c2684251700-888">{res?.name}</p>
              </div>
            </li>
          );
        })}
      </ul>
      {!isMobile && (
        <div
          onClick={() => setShow(true)}
          _ngcontent-serverapp-c2521702864
          className="btn search-btn ng-tns-c2521702864-98 ng-star-inserted"
          style={{}}
        >
          <span
            _ngcontent-serverapp-c2521702864
            className="item-icon ng-tns-c2521702864-98 ng-star-inserted"
            style={{
              maskImage: 'url("/assets/Icon/icon-search-type01.svg")',
            }}
          />
        </div>
      )}
    </div>
  );
};

export default FilterCasino;
